<ng-container *ngIf="formPrincipal">
  <div class="card-header">
    <div class="title-section">
      <h2 class="header-title">{{ modelRecived ? 'Editar Cargos (Cierre)' : 'Agregar Cargos (Cierre)' }}</h2>
    </div>
    <div class="search-section">
      <div class="button-section">
        <button class="btn-new" mat-raised-button color="accent" appPermissionControl="P135B0002" (click)="modelRecived ? update(form.value) : create(form.value)">
          <mat-icon>save</mat-icon>
          {{ modelRecived ? 'Actualizar' : 'Guardar' }}
        </button>
        <button class="btn-cancel" type="button" mat-raised-button (click)="close()" appPermissionControl="P135B0001"><mat-icon>arrow_back</mat-icon>Cancelar</button>
      </div>
    </div>
  </div>

  <form class="mt-5" [formGroup]="form" (submit)="modelRecived ? update(form.value) : create(form.value)" appPermissionControl="P135F0001">
    <div class="form-row">
      <div class="col-4">
        <div class="form-field" color="accent" appearance="outline">
          <label>Variable Id</label>
          <input id="numVar" class="form-control" formControlName="numVar" type="number" [readonly]="modelRecived" required appPermissionControl="P135K0001" />
        </div>
      </div>

      <div class="col-4">
        <div class="form-field" color="accent" appearance="outline">
          <label>Descripción</label>
          <input class="form-control" formControlName="descripcion" type="text" required appPermissionControl="P135K0002" />
        </div>
      </div>

      <div class="line-break"></div>

      <div class="col-4">
        <div class="form-field" color="accent" appearance="outline">
          <label>Concepto</label>
          <select class="form-control" formControlName="concepto" required appPermissionControl="P135K0003">
            <option value>-- Seleccione --</option>
            <option *ngFor="let concepto of conceptos" [value]="concepto.concepto">{{ concepto.concepto }} | {{ concepto.descripcion }}</option>
          </select>
        </div>
      </div>

      <div class="col-4">
        <div class="form-field" color="accent" appearance="outline">
          <label>Calcular</label>
          <select class="form-control" formControlName="calculate" appPermissionControl="P135K0004">
            <option value>-- Seleccione --</option>
            <option *ngFor="let element of calculate" [value]="element.iValor">{{ element.iValor }} | {{ element.sEtiqueta }}</option>
          </select>
        </div>
      </div>

      <div class="line-break"></div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Aplicar a</label>
        <select class="form-control" formControlName="aplicateTo" appPermissionControl="P135K0005">
          <option value>-- Seleccione --</option>
          <option *ngFor="let element of aplicateTo" [value]="element.iValor">{{ element.iValor }} | {{ element.sEtiqueta }}</option>
        </select>
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Factor</label>
        <select class="form-control" formControlName="claveTasa" required appPermissionControl="P135K0006">
          <option value>-- Seleccione --</option>
          <option *ngFor="let tasa of tasas" [value]="tasa.clave">{{ tasa.clave }} | {{ tasa.descripcion }}</option>
        </select>
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Fijado</label>
        <input class="form-control" placeholder="0.2" formControlName="valorFijo" type="number" appPermissionControl="P135K0007" />
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>% de Impuestos</label>
        <input class="form-control" placeholder="0.2" formControlName="porcentaje" type="number" required appPermissionControl="P135K0008" />
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Concepto</label>
        <select class="form-control" formControlName="conceptoAdicional" appPermissionControl="P135K0009">
          <option value>-- Seleccione --</option>
          <option *ngFor="let concepto of conceptos" [value]="concepto.concepto">{{ concepto.concepto }} | {{ concepto.descripcion }}</option>
        </select>
      </div>

      <div class="form-field" color="accent" appearance="outline">
        <label>Calcular</label>
        <select class="form-control" formControlName="calculate2" appPermissionControl="P135K0010">
          <option value>-- Seleccione --</option>
          <option *ngFor="let element of calculate2" [value]="element.iValor">{{ element.iValor }} | {{ element.sEtiqueta }}</option>
        </select>
      </div>
    </div>
  </form>
</ng-container>
